module.exports = __webpack_public_path__ + "static/media/12.77a939c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hair/12.png
// module id = 1253
// module chunks = 0